// Translations
import landing from '../views/landing/translations/ua'

// Translation: Register (Ukrainian)
export default Object.freeze({
	name: '',
	views: { landing }
})
